/**
 * Global fetch interceptor that modifies GIS map requests to include an Authorization header
 * when a token is present in the URL query parameters.
 *
 * This function overrides `window.fetch` globally, which means that if multiple
 * instances of the component call it, it could lead to race conditions or unexpected
 * behavior due to repeated redefinitions of `fetch`.
 *
 * If this function should not be used elsewhere whithout modifications
 * (such as implementing it as a singleton)
 */
export const setupFetchInterceptor = () => {
  const originalFetch = window.fetch

  window.fetch = async (input, init = {}) => {
    let url
    const ARC_SERVER = import.meta.env.LH_TIMP_ARC_SERVER as string

    if (typeof input === 'string') {
      url = input
    } else if (input instanceof Request) {
      url = input.url
    } else {
      return originalFetch(input, init) // Fallback to normal fetch
    }

    if (url.includes(ARC_SERVER)) {
      const urlObj = new URL(url)
      const token = urlObj.searchParams.get('token')

      if (token) {
        urlObj.searchParams.delete('token')

        init = init || {}
        init.headers = new Headers(init.headers || {})

        init.headers.set('Authorization', `Bearer ${token}`)

        input = urlObj.toString()

        return originalFetch(input, init)
      }
    }

    return originalFetch(input, init)
  }

  return () => {
    window.fetch = originalFetch // Restore original fetch when unmounted
  }
}
